import React from 'react';
import { Link } from 'react-router-dom';
import '@fontsource/metropolis';

function CustomLabel({ type, value, redirect, style = {}, font = 'metropolis' }) {
  const finalStyle = { ...style };
  finalStyle.fontFamily = font;
  switch (type) {
    case 'h1':
      return <h1 style={finalStyle}>{value}</h1>;
    case 'p':
      return <p style={finalStyle}>{value}</p>;
    case 'link':
      return (
        <Link to={redirect} style={finalStyle}>
          {value}
        </Link>
      );
    default:
      return { value };
  }
}

export default CustomLabel;
